import helper from '@/libs/forms';
import schemaHelper from '@/components/profile/sections/tabs/financial/resources/schemaHelper';


const automobileFields = () => {
  const defaultFields = [
    helper.currency('Amount', 'amount', true),
    helper.boolRadio(
      'Do you have an Installment Account for this automobile?',
      'installment',
      true,
    ),
  ];

  const additionalFields = [
    helper.currency('Liability Amount', 'liabilityAmount', true),
    helper.simpleInput('text', 'Institution', null, 'institution', true),
    helper.simpleInput('text', 'Account Number', null, 'accountNumber', false),
    helper.currency('Monthly Payment', 'monthlyPayment', true),
  ];
  schemaHelper.setVisibility(schemaHelper.boolFieldVisibility, additionalFields, 'installment');

  return defaultFields.concat(additionalFields);
};


export default { fields: automobileFields() };



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/financial/assets/schemas/automobiles.js